import { Model } from '@vuex-orm/core';

export default class Log extends Model {
  static entity = 'log';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {any} */
    this.logtime;
    /** @type {number | null} */
    this.userid;
    /** @type {string | null} */
    this.ip;
    /** @type {string | null} */
    this.action;
    /** @type {string | null} */
    this.data1;
    /** @type {string | null} */
    this.data2;
    /** @type {string | null} */
    this.data3;
    /** @type {number | null} */
    this.id;
  }

  static fields() {
    return {
      logtime: this.attr(undefined).nullable(),
      userid: this.number(0).nullable(),
      ip: this.string('').nullable(),
      action: this.string('').nullable(),
      data1: this.string('').nullable(),
      data2: this.string('').nullable(),
      data3: this.string('').nullable(),
      id: this.number(0).nullable()
    };
  }
}
